export default __webpack_public_path__ + "static/media/google-login-logo.aa538d7f.png";